import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appliedDiscount = {
    discountAmount: 'DOUBLE',
    afterDiscountAmount: 'DOUBLE',
};
var _calculateRequest = { discount: '_specification', cart: '_cart' };
var _calculateResponse = { cart: '_cart' };
var _cart = {
    lineItems: '_lineItem',
    shipping: '_shipping',
    totals: '_totals',
};
var _coupon = { specification: '_specification' };
var _createCouponRequest = { specification: '_specification' };
var _createCouponResponse = {};
var _deleteCouponRequest = {};
var _deleteCouponResponse = {};
var _getCouponRequest = {};
var _getCouponResponse = { coupon: '_coupon' };
var _hasCouponsRequest = {};
var _hasCouponsResponse = {};
var _increaseUsageRequest = {};
var _increaseUsageResponse = {};
var _lineItem = { amount: 'DOUBLE', appliedDiscount: '_appliedDiscount' };
var _listCouponsRequest = {};
var _listCouponsResponse = { coupons: '_coupon' };
var _shipping = { amount: 'DOUBLE', appliedDiscount: '_appliedDiscount' };
var _specification = {
    moneyOffAmount: 'DOUBLE',
    percentOffRate: 'DOUBLE',
    fixedPriceAmount: 'DOUBLE',
    minimumSubtotal: 'google.protobuf.DoubleValue',
};
var _totals = { subTotal: 'DOUBLE', discount: 'DOUBLE', total: 'DOUBLE' };
var _updateCouponRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    specification: '_specification',
};
var _updateCouponResponse = {};
function resolveWixCouponsApiV1CouponsUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v2/coupons',
                destPath: '/v2/coupons',
            },
            {
                srcPath: '/stores/v2/bulk/coupons',
                destPath: '/v2/bulk/coupons',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/coupons-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/coupons-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** create a coupon. if a coupon with the same id already exist - an error will be returned */
export function create(payload) {
    var _a = serializer(_createCouponRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCouponResponse, {}).fromJSON;
    function __create(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v1.Coupons.Create',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __create.fromReq = fromReq;
    __create.__isAmbassador = true;
    return __create;
}
/** update a coupon. changing coupon type is not allowed */
export function update(payload) {
    var _a = serializer(_updateCouponRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCouponResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'PATCH',
            methodFqn: 'wix.coupons.api.v1.Coupons.Update',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** retrieve a coupon by id or code */
export function get(payload) {
    var _a = serializer(_getCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCouponResponse, {
        _coupon: _coupon,
        _specification: _specification,
    }).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'GET',
            methodFqn: 'wix.coupons.api.v1.Coupons.Get',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
export function _delete(payload) {
    var _a = serializer(_deleteCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCouponResponse, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'DELETE',
            methodFqn: 'wix.coupons.api.v1.Coupons._Delete',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/**
 * get list of coupons according to the request pagination.
 * no more than 100 coupons will be returned per request
 */
export function list(payload) {
    var _a = serializer(_listCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCouponsResponse, {
        _coupon: _coupon,
        _specification: _specification,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'GET',
            methodFqn: 'wix.coupons.api.v1.Coupons.List',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/**
 * calculate the cart with the coupon.
 * cart with line items and shipping will be passed and the cart will be returned
 * along with its coupons calculations applied
 */
export function calculateCart(payload) {
    var _a = serializer(_calculateRequest, {
        _appliedDiscount: _appliedDiscount,
        _cart: _cart,
        _lineItem: _lineItem,
        _shipping: _shipping,
        _specification: _specification,
        _totals: _totals,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateResponse, {
        _appliedDiscount: _appliedDiscount,
        _cart: _cart,
        _lineItem: _lineItem,
        _shipping: _shipping,
        _totals: _totals,
    }).fromJSON;
    function __calculateCart(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v1.Coupons.CalculateCart',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/codes/{code}/calculate-cart',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateCart.fromReq = fromReq;
    __calculateCart.__isAmbassador = true;
    return __calculateCart;
}
/**
 * increase coupon usage increase the usage counter of the coupon
 * it is the responsibility of the payment process to call it after
 * the coupon was used
 */
export function increaseUsage(payload) {
    var _a = serializer(_increaseUsageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_increaseUsageResponse, {}).fromJSON;
    function __increaseUsage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'POST',
            methodFqn: 'wix.coupons.api.v1.Coupons.IncreaseUsage',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/{id}/increase-usage',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __increaseUsage.fromReq = fromReq;
    __increaseUsage.__isAmbassador = true;
    return __increaseUsage;
}
/**
 * get list of coupons according to the request pagination.
 * no more than 100 coupons will be returned per request
 */
export function hasCoupons(payload) {
    var _a = serializer(_hasCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hasCouponsResponse, {}).fromJSON;
    function __hasCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.coupons.api.v1.coupon',
            method: 'GET',
            methodFqn: 'wix.coupons.api.v1.Coupons.HasCoupons',
            url: resolveWixCouponsApiV1CouponsUrl({
                protoPath: '/api/v1/coupons/has-coupons',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hasCoupons.fromReq = fromReq;
    __hasCoupons.__isAmbassador = true;
    return __hasCoupons;
}
//# sourceMappingURL=http.impl.js.map